/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Op_RunningInputs */



/**
* | output |
* | --- |
* | "Running…" |
*
* @param {Admin_Op_RunningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_op_running = /** @type {((inputs?: Admin_Op_RunningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Op_RunningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En cours…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ejecutando…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Executando…")
	if (locale === "it") return /** @type {LocalizedString} */ ("In esecuzione…")
	return /** @type {LocalizedString} */ ("Running…")
});